import React from 'react';
import Selectors from '@/auth/hooks/selectors';

const ApprovedContainer = ({ children }) => {
  const { approved } = Selectors.useApprovedAuthenticated();
  if (!approved) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
};

export default ApprovedContainer;
